var $070e1709fddbf199$exports = {};
$070e1709fddbf199$exports = {
    "collectionLabel": `Predlogi`
};


export {$070e1709fddbf199$exports as default};
//# sourceMappingURL=sl-SI.module.js.map
